<template>
  <template v-if="hasContent">
    <transition-fade :duration="500" appear>
      <material-box
        id="material-box-year"
        :title="activeSeasonContentForSchoolLevel?.materialTitleYear"
        :content="activeSeasonContentForSchoolLevel?.materialContentYear"
      />
    </transition-fade>
    <transition-fade :duration="500" appear>
      <material-box
        id="material-box-holiday"
        :title="activeSeasonContentForSchoolLevel?.materialTitleHoliday"
        :content="activeSeasonContentForSchoolLevel?.materialContentHoliday"
      />
    </transition-fade>
    <transition-fade :duration="500" appear>
      <material-box
        id="material-box-issue"
        :title="activeSeasonContentForSchoolLevel?.materialTitleIssue"
        :content="activeSeasonContentForSchoolLevel?.materialContentIssue"
      />
    </transition-fade>
  </template>
  <div v-else class="flex h-full justify-center items-center">
    <box-generic header="Geen materiaal">
      <p class="leading-relaxed">
        In deze aflevering zijn er geen materialen<br />
        voor het onderdeel “Materiaal” beschikbaar.
      </p>
    </box-generic>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import BoxGeneric from "../../../../components/content/BoxGeneric.vue";
import MaterialBox from "../../../../components/content/season/MaterialBox.vue";
import TransitionFade from "../../../../components/magic/TransitionFade.vue";

import lightboxInitialize from "../../../../components/content/lightbox-initialize";
import lightboxDestroy from "../../../../components/content/lightbox-destroy";

export default {
  name: "MaterialContent",
  components: {
    BoxGeneric,
    MaterialBox,
    TransitionFade,
  },
  computed: {
    ...mapGetters(["activeSeasonContentForSchoolLevel"]),
    hasContent() {
      return [
        "materialTitleYear",
        "materialContentYear",
        "materialTitleHoliday",
        "materialContentHoliday",
        "materialTitleIssue",
        "materialContentIssue",
      ].some((key) => this.activeSeasonContentForSchoolLevel?.[key].length);
    },
  },
  watch: {
    activeSeasonContentForSchoolLevel() {
      this.$nextTick(() => {
        lightboxDestroy();
        lightboxInitialize();
      });
    },
  },
  mounted() {
    lightboxInitialize();
  },
  beforeUnmount() {
    lightboxDestroy();
  },
};
</script>

<style scoped lang="css">
.material-box {
  font-weight: 300;
  margin: 1.5625em 1.125em;
  max-width: 48%;
  width: 100%;

  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;

  &:not(:last-child) {
    max-height: 60%;
  }

  &:last-child {
    max-height: 100%;
  }

  @media (max-width: 1050px) {
    &:not(:last-child) {
      max-width: 44%;
    }
    &:last-child {
      max-width: 52%;
    }
  }
}
</style>
